import CentralCalls from '../../../centralCalls';
import { createDataAdapter, normalizeRowsResult } from './adapterContract';

const centralCallsAdapter = createDataAdapter({
  async executeProcedure(procedureName, params) {
    console.log('running proc', procedureName, params);
    return CentralCalls.callStoredProcedureWithParams(procedureName, params || {});
  },

  async queryTable(tableName, optionalWhere) {
    if (optionalWhere && Object.keys(optionalWhere).length > 0) {
      return CentralCalls.fetchTableData(tableName, optionalWhere);
    }

    return CentralCalls.fetchTableDataNoWhere(tableName);
  },

  normalizeProcedureResult(raw) {
    return normalizeRowsResult(raw);
  }
});

export default centralCallsAdapter;
